import { makeStyles } from '@material-ui/core/styles';

export const styles = makeStyles((theme) => ({
  formControl: {
    width: '100%',
  },
}));